
import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import PageLoader from './components/common/PageLoader';

function App() {
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isPageReady, setIsPageReady] = useState(false);

  useEffect(() => {
    // 简化加载逻辑，确保页面能正常显示
    const timer = setTimeout(() => {
      setIsPageReady(true);
    }, 800);

    // 优化错误处理，避免null错误
    const handleError = (event: ErrorEvent) => {
      // 只记录有意义的错误信息
      if (event.error && event.error.message) {
        console.warn('页面加载警告:', event.error.message);
      }
      // 确保页面继续加载
      setIsPageReady(true);
    };

    // 添加未捕获的Promise错误处理
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.warn('Promise错误:', event.reason);
      // 阻止错误显示在控制台
      event.preventDefault();
      setIsPageReady(true);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  const handleLoadComplete = () => {
    setIsInitialLoading(false);
    // 恢复body的默认样式
    document.body.style.backgroundColor = '';
    document.body.style.background = '';
  };

  // 显示初始加载动效直到页面完全准备好
  if (isInitialLoading) {
    return <PageLoader onLoadComplete={handleLoadComplete} isPageReady={isPageReady} />;
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen w-full">
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
